document.addEventListener('DOMContentLoaded', () =>{
  const modalButtons = document.querySelectorAll('[data-modal-button]');

  modalButtons.forEach(button=>{
    button.addEventListener('click', (e)=> {
      e.preventDefault();
      const modalId = button.getAttribute('data-modal-button');
      const modal = document.getElementById(modalId);
      if (!modal) {
        console.error(`Modal with id ${modalId} not found`);
        return;
      };
      modal.activate();
    })
  })
})

if(!customElements.get('byte-modal')){
  class ByteModal extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('[data-modal-close]');
      if(this.closeButton){
        this.closeButton.addEventListener('click', (e)=> {
          e.preventDefault();
          this.deactivate();
        })
      }
      this.addEventListener('keydown', (e)=> {
        if(e.key === 'Escape'){
          this.deactivate();
        }
      })
    }
    activate() {
      this.classList.add('active');
      document.body.classList.add('modal-open');
      this.addEventListener('click', (e)=> {
        if(e.target.classList.contains('byte-modal')){
          this.deactivate();
        }
      })
    }
    deactivate() {
      this.classList.remove('active');
      document.body.classList.remove('modal-open');
    }
  }

  customElements.define('byte-modal', ByteModal);
}